import { render, staticRenderFns } from "./ehc-card-content.vue?vue&type=template&id=7c8cb175"
import script from "./ehc-card-content.vue?vue&type=script&lang=js"
export * from "./ehc-card-content.vue?vue&type=script&lang=js"
import style0 from "./ehc-card-content.vue?vue&type=style&index=0&id=7c8cb175&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports